import applemackbookaira2337 from "../assets/apple/AppleMacbookAirA2337.jpg";
import applemackbookaira2681 from "../assets/apple/AppleMacbookAirA2681.jpg";
import applemackbookproa2141 from "../assets/apple/AppleMacbookProA2141.jpg";
import applemackbookproa2289 from "../assets/apple/AppleMacbookProA2289.jpg";
import applemackbookproa2442 from "../assets/apple/AppleMacbookProA2442.jpg";
import applemackbookproa2141_1 from "../assets/apple/AppleMacbookProA2141-1.jpeg";

const appleProducts = [
  {
    id: 1,
    name: "Apple Mackbook Air A2337",
    image: applemackbookaira2337,
    specs: [
      "M1 processor",
      "8GB RAM",
      "512GB SSD",
      "13.3 2K Retina display",
      "Mac OS Sequoia",
    ],
    price: "₹62,999",
    whatsappText: "Hi, I am interested in Apple Mackbook Air A2337",
  },
  {
    id: 2,
    name: "Apple Macbook Air (A2681)",
    image: applemackbookaira2681,
    specs: [
      "Apple warranty till April 2027",
      "M2 Processor",
      "256 GB SSD",
      "13.3 2K Retina Display",
      "Mac OS Sequoia",
    ],
    price: "₹58,999",
    whatsappText: "Hi, I am interested in Apple Macbook Air (A2681)",
  },
  {
    id: 3,
    name: "Apple Macbook Pro (A2141)",
    image: applemackbookproa2141,
    specs: [
      "Intel i9 Processor",
      "64GB RAM",
      "8 TB Storage",
      "16 4k Retina display",
      "AMD Radeon 4GB GPU",
      "Touchbar Keyboard",
      "Mac OS Sequoia",
    ],
    price: "₹1,45,999",
    whatsappText: "Hi, I am interested in Apple Macbook Pro (A2141)",
  },
  {
    id: 4,
    name: "Apple Macbook Pro (A2289)",
    image: applemackbookproa2289,
    specs: [
      "Intel i7 Processor",
      "8GB RAM",
      "512 GB Storage",
      "13.3 2k Retina display",
      "Touchbar Keyboard",
      "Mac OS Sequoia",
    ],
    price: "₹1,05,999",
    whatsappText: "Hi, I am interested in Apple Macbook Pro (A2289)",
  },
  {
    id: 5,
    name: "Apple Macbook Pro (A2442)",
    image: applemackbookproa2442,
    specs: [
      "M1 pro processor",
      "16GB RAM",
      "512 GB Storage",
      "14 Cores GPU",
      "4K Retina Display",
      "Mac OS Sequoia",
    ],
    price: "₹1,05,999",
    whatsappText: "Hi, I am interested in Apple Macbook Pro (A2442)",
  },
  {
    id: 6,
    name: "Apple Macbook Pro A2141",
    image: applemackbookproa2141_1,
    specs: [
      "i9 processor (8 cores)",
      "64 GB RAM",
      "500 GB SSD",
      "15.4 4K display",
      "Touchbar keyboard",
      "AMD Radeon pro 5500M 8GB GPU",
      "Mac OS Sonoma",
    ],
    price: "₹1,05,999",
    whatsappText: "Hi, I am interested in Apple Macbook Pro A2141",
  }
];

export default appleProducts;
